import { onMounted, onUnmounted } from 'vue';
import { useUserStore } from '@/stores/user';

export type CandidateUpdateType = 'messages' | 'file_requests';

interface CandidateUpdatedMessage {
  candidateEntityId: string;
  type: CandidateUpdateType;
}

const CANDIDATE_UPDATED_ACTION = 'funnel.candidate.updated';

/**
 * Calls `onUpdate` whenever the backend pushes a change of the given type for the candidate.
 * Only fires while the page has joined the customer's funnel channel.
 */
export function useCandidateUpdates(
  candidateEntityId: () => string,
  type: CandidateUpdateType,
  onUpdate: () => void
): void {
  const userStore = useUserStore();

  const handleCandidateUpdated = (message: CandidateUpdatedMessage) => {
    if (message.candidateEntityId === candidateEntityId() && message.type === type) {
      onUpdate();
    }
  };

  onMounted(() => userStore.ws?.registerActionHandler(CANDIDATE_UPDATED_ACTION, handleCandidateUpdated));
  onUnmounted(() => userStore.ws?.unregisterActionHandler(CANDIDATE_UPDATED_ACTION, handleCandidateUpdated));
}
